// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/accolades-carousel-item/accolades-carousel-item.component.scss
// module id = 71
// module chunks = 0